import VwPersonelDTO from "src/models/GenelTanimlar/VwPersonelDTO";

class VwKullaniciDTO {
  id?: number = 0;
  kodu?: string = "";
  sifre?: string = "";
  kimlikNo?: string = "";
  adi?: string = "";
  soyadi?: string = "";
  dogumTarihi?: string = null;
  personelId?: number = null;
  email?: string = "";
  tel1?: string = "";
  ekleyenKullanici?: number = null;
  eklemeTarihi?: string = null;
  guncelleyenKullanici?: number = null;
  guncellemeTarihi?: string = null;
  super?: string = "H";
  superBool?: boolean = false;
  sifreDegistirmeTarih?: string = null;
  personelAdSoyad?: string = "";
  kimlikId?: number = null;
  ekleyenKullaniciAd?: string = "";
  guncelleyenKullaniciAd?: string = "";
  aktif?: string = "E";
  aktifBool?: boolean = true;
  ascKodu?: string = "";
  yenisifreverildi?: string = "H";
  yenisifreverildiBool?: boolean = false;
  aileAdi?: string = "";
  sifreDegisti?: boolean = false;
  grupId?: number = null;
  disKulKendiHastalariGorsun?: string = "H";
  disKulKendiHastalariGorsunBool?: boolean = false;
  searchText?: string = "";
  //View Dışı
  sifreTekrar?: string = "";
  patolojiOnayYapabilir?: string = "H";
  patolojiOnayYapabilirBool?: boolean = false;
  //View dışı aynı dto 2 kere oluşturulduğu için ekledim. --Emirhan
  personelData?: VwPersonelDTO;
  bransId?: number = null;
  doktorOlarakEkle?: string = "H";
  servisId?: number = null;
}
export default VwKullaniciDTO;